import { Link } from 'react-router-dom';
import { campaigns } from '@/mocks/campaigns';
import CampaignCard from '@/components/feature/CampaignCard';
import useSectionAnimation from '@/hooks/useSectionAnimation';

const FeaturedCampaigns = () => {
  const { ref, fadeUp, stagger } = useSectionAnimation({ threshold: 0.08 });
  const featured = campaigns.slice(0, 3);

  return (
    <section ref={ref} className="py-20 bg-stone-50" dir="rtl">
      <div className="max-w-7xl mx-auto px-8 md:px-12">
        {/* Header */}
        <div className="flex items-end justify-between mb-10" style={fadeUp}>
          <div>
            <span className="text-emerald-600 text-sm font-semibold tracking-wide uppercase">أبرز الحملات</span>
            <h2 className="text-2xl md:text-4xl font-black text-stone-800 mt-1">
              حملات تستحق دعمك
            </h2>
            <p className="text-stone-500 mt-2 text-sm">اختارها فريقنا بعناية لتأثيرها الحقيقي</p>
          </div>
          <Link
            to="/explore"
            className="hidden md:inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            عرض الكل
            <i className="ri-arrow-left-line"></i>
          </Link>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((campaign, i) => (
            <div key={campaign.id} style={stagger(i, 120)}>
              <CampaignCard campaign={campaign} size="large" index={i} />
            </div>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden" style={fadeUp}>
          <Link
            to="/explore"
            className="inline-flex items-center gap-2 text-emerald-600 font-semibold text-sm cursor-pointer"
          >
            عرض جميع الحملات
            <i className="ri-arrow-left-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCampaigns;
